// extracted by mini-css-extract-plugin
export default {"unrespondedMessageWrapper":"unrespondedMessageWrapper__MzIwY","unrespondedMessage":"unrespondedMessage__Y2JjM","withBanner":"withBanner__OWFhM"};